import * as EmailValidator from 'email-validator';

export const getAddressesAndValidity = (emailAddresses) => {
    if (!emailAddresses) {
        return [];
    }

    // https://stackoverflow.com/a/37334192
    const addressList = emailAddresses
        .split(',')
        .map((e) => e.split(';'))
        .flat();

    const checkedAddresses = [];

    addressList.forEach((emailAddressProvided) => {
        if (!emailAddressProvided) {
            return;
        }

        const emailAddress = emailAddressProvided.trim();

        if (!emailAddress) {
            return;
        }

        const isValid = EmailValidator.validate(emailAddress);

        checkedAddresses.push({ emailAddress, isValid });
    });

    return checkedAddresses;
};
